/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * How one stage of the probe ended.
 */
export enum DiagnosticOutcome {
    PASSED = 'passed',
    FAILED = 'failed',
    WARNED = 'warned',
    SKIPPED = 'skipped',
}
